import { claimPreloadErrorRecoveryAttempt, runPreloadErrorRecovery } from 'src/util/pwa/preloadErrorRecovery';

const updateServiceWorkers = async (): Promise<void> => {
	if (!('serviceWorker' in navigator)) {
		return;
	}

	const registrations = await navigator.serviceWorker.getRegistrations();
	await Promise.all(registrations.map((registration) => registration.update()));
};

const deleteAllCaches = async (): Promise<void> => {
	if (typeof caches === 'undefined') {
		return;
	}

	const cacheKeys = await caches.keys();
	await Promise.all(cacheKeys.map((cacheKey) => caches.delete(cacheKey)));
};

export function bootPreloadErrorRecovery(): void {
	if (typeof window === 'undefined') {
		return;
	}

	const buildVersion = typeof __APP_VERSION__ === 'undefined' ? 'dev' : __APP_VERSION__;

	window.addEventListener('vite:preloadError', (event) => {
		if (!claimPreloadErrorRecoveryAttempt(window.sessionStorage, buildVersion)) {
			return;
		}

		event.preventDefault();
		void runPreloadErrorRecovery({
			clearCaches: deleteAllCaches,
			reloadPage: () => {
				window.location.reload();
			},
			updateServiceWorker: updateServiceWorkers,
		});
	});
}
